import {
    Component,
    Type,
    ViewEncapsulation,
    ComponentRef,
    ViewChild,
    ComponentFactoryResolver,
    ChangeDetectorRef,
    OnDestroy,
    AfterViewInit,
} from "@angular/core";
import { Subject } from "rxjs";
import { RoblexModalConfig } from '../../config/modal/modal.config';
import { RoblexModalRef } from '../../config/modal/modal.ref';
import { InsertionDirective } from '../../directives/insertion.directive';

@Component({
    selector: "roblex-modal",
    templateUrl: "./modal.component.html",
    styleUrls: ["./modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements AfterViewInit, OnDestroy {
    /**
     * Component ref of modal component
     */
    componentRef: ComponentRef<any>;
    /**
     * Unique key of modal component
     */
    uniqueKey: number;
    /**
     * View child of modal component
     */
    @ViewChild(InsertionDirective) insertionPoint: InsertionDirective;
    /**
     * Determines whether close on
     */
    private readonly _onClose = new Subject<any>();
    /**
     * Determines whether close on
     */
    public onClose = this._onClose.asObservable();
    /**
     * Child component type of modal component
     */
    childComponentType: Type<any>;
    /**
     * Creates an instance of modal component.
     * @param componentFactoryResolver ComponentFactoryResolver
     * @param cd ChangeDetectorRef
     * @param neyhazModalRef NeyhazModalRef
     */
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private cd: ChangeDetectorRef,
        private neyhazModalRef: RoblexModalRef,
        public roblexModalConfig: RoblexModalConfig
    ) {
        //
    }
    /**
     * after view init
     */
    ngAfterViewInit() {
        this.loadChildComponent(this.childComponentType);
        this.cd.detectChanges();
    }
    /**
     * Determines whether overlay clicked on
     * @param evt MouseEvent
     */
    onOutsideClicked(evt: MouseEvent) {
        if (this.roblexModalConfig.backdrop) {
            this.neyhazModalRef.close();
        }
    }
    /**
     * Determines whether dialog clicked on
     * @param evt MouseEvent
     */
    onDialogClicked(evt: MouseEvent) {
        evt.stopPropagation();
    }
    /**
     * Loads child component
     * @param componentType Type<any>
     */
    loadChildComponent(componentType: Type<any>) {
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            componentType
        );

        let viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();

        this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
    /**
     * on destroy
     */
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }
    /**
     * Closes modal component
     */
    close() {
        this._onClose.next();
    }
}
